/**
 * Auto bind instance methods of classes.
 * @module abind
 * @version 1.0.5
 */
'use strict';

var abind = require('./abind');

var lib = abind.bind(void 0);
Object.assign(lib, abind, {
  abind: abind
});
module.exports = lib;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbImFiaW5kIiwicmVxdWlyZSIsImxpYiIsImJpbmQiLCJPYmplY3QiLCJhc3NpZ24iLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7QUFNQTs7QUFFQSxJQUFNQSxLQUFLLEdBQUdDLE9BQU8sQ0FBQyxTQUFELENBQXJCOztBQUVBLElBQUlDLEdBQUcsR0FBR0YsS0FBSyxDQUFDRyxJQUFOLFFBQVY7QUFFQUMsTUFBTSxDQUFDQyxNQUFQLENBQWNILEdBQWQsRUFBbUJGLEtBQW5CLEVBQTBCO0FBQ3hCQSxFQUFBQSxLQUFLLEVBQUxBO0FBRHdCLENBQTFCO0FBSUFNLE1BQU0sQ0FBQ0MsT0FBUCxHQUFpQkwsR0FBakIiLCJzb3VyY2VSb290IjoiLi4vLi4vbGliIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBBdXRvIGJpbmQgaW5zdGFuY2UgbWV0aG9kcyBvZiBjbGFzc2VzLlxuICogQG1vZHVsZSBhYmluZFxuICogQHZlcnNpb24gMS4wLjVcbiAqL1xuXG4ndXNlIHN0cmljdCdcblxuY29uc3QgYWJpbmQgPSByZXF1aXJlKCcuL2FiaW5kJylcblxubGV0IGxpYiA9IGFiaW5kLmJpbmQodGhpcylcblxuT2JqZWN0LmFzc2lnbihsaWIsIGFiaW5kLCB7XG4gIGFiaW5kXG59KVxuXG5tb2R1bGUuZXhwb3J0cyA9IGxpYlxuIl19